import typographyGaImageImprovedLegibility from "../../../../src/pages/whats-new/new-typography-in-general-availability/_images/typography-ga-improved-legibility.png";
import typographyGaImageMetricText from "../../../../src/pages/whats-new/new-typography-in-general-availability/_images/typography-ga-metric-text.png";
import typographyGaImageGreek from "../../../../src/pages/whats-new/new-typography-in-general-availability/_images/typography-ga-greek.png";
import { Stack } from '@atlaskit/primitives/compiled/stack';
import * as React from 'react';
export default {
  typographyGaImageImprovedLegibility,
  typographyGaImageMetricText,
  typographyGaImageGreek,
  Stack,
  React
};